/**
 * payment 도메인 React Query keys.
 *
 * 컨벤션: UPPER_SNAKE_CASE 상수.
 * gacha의 GACHA_KEYS / service-area의 INVOICE_KEYS와 동일 패턴.
 */
export const PAYMENT_KEYS = {
  ORDERS: 'PAYMENT_ORDERS',
  ORDER_DETAIL: 'PAYMENT_ORDER_DETAIL',
  SEALED_ORDER_DETAIL: 'PAYMENT_SEALED_ORDER_DETAIL',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  SEALED_ORDER_AVAILABILITY: 'PAYMENT_SEALED_ORDER_AVAILABILITY',
  SEALED_ITEM_STOCK: 'PAYMENT_SEALED_ITEM_STOCK',
  PRODUCT_PAYMENT_PROCESS: 'PAYMENT_PRODUCT_PAYMENT_PROCESS',
  KAKAOPAY_CALLBACK: 'PAYMENT_KAKAOPAY_CALLBACK',
} as const
